import React from 'react';
import { formatUtcToIst } from '../utils/datetime';
import { formatDuration } from '../../workforce/api/workforceApi';

function TicketWorkTimePanel({ summary, loading, error }) {
  if (loading) {
    return <p style={{ fontSize: 13, color: '#6B7280', margin: 0 }}>Loading work time…</p>;
  }
  if (error) {
    return <p style={{ fontSize: 13, color: '#B91C1C', margin: 0 }}>{error}</p>;
  }
  if (!summary) {
    return <p style={{ fontSize: 13, color: '#94A3B8', margin: 0 }}>No work-time data yet.</p>;
  }

  const workers = summary.workers || [];
  const transitions = summary.status_transitions || [];

  return (
    <div className="tk-work-time">
      <div className="tk-work-time-stats">
        <div className="tk-work-time-stat">
          <span className="tk-work-time-stat-label">Total active work</span>
          <span className="tk-work-time-stat-value">{formatDuration(summary.total_active_seconds)}</span>
        </div>
        <div className="tk-work-time-stat">
          <span className="tk-work-time-stat-label">
            Wall clock (created → {
              summary.wall_clock_ends_at === 'completed' || summary.completed_at
                ? 'completed'
                : (summary.closed_at ? 'closed' : 'now')
            })
          </span>
          <span className="tk-work-time-stat-value">{formatDuration(summary.wall_clock_seconds)}</span>
        </div>
        <div className="tk-work-time-stat">
          <span className="tk-work-time-stat-label">Current status · {summary.current_status_label}</span>
          <span className="tk-work-time-stat-value">{formatDuration(summary.current_status_seconds)}</span>
        </div>
      </div>

      <h4 className="tk-work-time-heading">People who worked this ticket</h4>
      {workers.length === 0 ? (
        <p style={{ fontSize: 12, color: '#94A3B8', margin: '0 0 16px' }}>No work sessions recorded for this ticket.</p>
      ) : (
        <div className="tk-table-wrap" style={{ marginBottom: 16, boxShadow: 'none' }}>
          <table className="tk-table">
            <thead>
              <tr>
                <th>Person</th>
                <th>Active time</th>
                <th>Sessions</th>
                <th>Session detail</th>
              </tr>
            </thead>
            <tbody>
              {workers.map((w) => (
                <tr key={w.user_id}>
                  <td style={{ fontWeight: 600 }}>{w.user_name}</td>
                  <td>{formatDuration(w.active_seconds)}</td>
                  <td>{w.session_count}</td>
                  <td style={{ fontSize: 12, color: '#475569' }}>
                    {(w.sessions || []).length === 0 ? '—' : (w.sessions || []).map((s, i) => (
                      <div key={i}>
                        {formatUtcToIst(s.started_at)}
                        {s.ended_at ? ` → ${formatUtcToIst(s.ended_at)}` : ' → still active'}
                        {' · '}
                        {formatDuration(s.active_seconds)}
                      </div>
                    ))}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <h4 className="tk-work-time-heading">Time in each status</h4>
      {transitions.length === 0 ? (
        <p style={{ fontSize: 12, color: '#94A3B8', margin: 0 }}>No status history recorded yet.</p>
      ) : (
        <div className="tk-table-wrap" style={{ boxShadow: 'none' }}>
          <table className="tk-table">
            <thead>
              <tr>
                <th>Transition</th>
                <th>Time spent before change</th>
                <th>Changed at (IST)</th>
                <th>By</th>
                <th>Reason</th>
              </tr>
            </thead>
            <tbody>
              {transitions.map((t, i) => (
                <tr key={`${t.to_status}-${i}`}>
                  <td style={{ fontWeight: 600 }}>{t.label}</td>
                  <td>{formatDuration(t.duration_in_from_seconds)}</td>
                  <td style={{ whiteSpace: 'nowrap' }}>{formatUtcToIst(t.changed_at)}</td>
                  <td>{t.changed_by_name || '—'}</td>
                  <td style={{ maxWidth: 220 }}>{t.reason || '—'}</td>
                </tr>
              ))}
              <tr>
                <td style={{ fontWeight: 600 }}>
                  {summary.current_status_label} (current)
                </td>
                <td>{formatDuration(summary.current_status_seconds)}</td>
                <td colSpan={3} style={{ color: '#64748B', fontSize: 12 }}>
                  Time in the latest status since the last change
                  {summary.closed_at ? ' (until close)' : (summary.completed_at && summary.status === 'completed' ? ' (waiting for close)' : ' (until now)')}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default TicketWorkTimePanel;
